import { useTranslation } from 'react-i18next';
import { TableRow, TableCell } from '@mui/material';

const VirtualTableNoDataCell = () => {
  const { t } = useTranslation();

  return (
    <TableRow
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <TableCell
        sx={{
          borderBottom: 'none',
          flexGrow: 1,
          position: 'sticky',
          '& big:first-of-type': {
            position: 'sticky',
            left: '50%',
          },
        }}
      >
        <big>
          <span>{t('dataGridFlexSales.labels.noRows')}</span>
        </big>
      </TableCell>
    </TableRow>
  );
};

export default VirtualTableNoDataCell;
